import { APIModel } from './api-model.model'

export class APIPermission extends APIModel {
    permissionId: number;
    permissionName: string;
    permissionEnabled: number;
    active?: boolean;
    locked?: boolean;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        permissionId: number;
        permissionName: string;
        permissionEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.permissionId = params.permissionId
        this.permissionName = params.permissionName
        this.permissionEnabled = params.permissionEnabled ? 1 : 0
    }
}
